import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import ArticleCard from "../components/ArticleCard";
import { NAV_CATEGORIES } from "../mock";
import { fetchArticles } from "../api";

const CategoryPage = () => {
  const { slug } = useParams();
  const category = NAV_CATEGORIES.find((c) => c.slug === slug);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticles({ category: slug })
      .then(setArticles)
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 fade-in">
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-sq-orange">Home</Link>
        <span>/</span>
        <span className="text-sq-navy font-medium">{category ? category.name : slug}</span>
      </div>

      <h1 className="font-serif-display text-4xl text-sq-navy mb-2">
        {category ? category.name : "Categoria"}
      </h1>
      <div className="w-16 h-1 bg-sq-orange mb-8" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          {loading ? (
            <p className="text-gray-400">Caricamento...</p>
          ) : articles.length === 0 ? (
            <p className="text-gray-500">Nessun articolo disponibile in questa sezione.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {articles.map((a) => (
                <ArticleCard key={a.id} article={a} />
              ))}
            </div>
          )}
        </div>
        <Sidebar />
      </div>
    </div>
  );
};

export default CategoryPage;
